import { render, staticRenderFns } from "./BSwitch.vue?vue&type=template&id=194351ab&"
import script from "./BSwitch.vue?vue&type=script&lang=js&"
export * from "./BSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports